import { useLocale } from "@hooks/useLocale";
import type { MessageKey } from "@i18n/messages";

/**
 * Stub screen for sitemap routes not yet built out. Keeps navigation whole in
 * the Phase 0 foundation while signalling clearly that the screen is pending.
 */
export function Placeholder({ titleKey }: { titleKey: MessageKey }) {
  const { t } = useLocale();
  return (
    <div>
      <div className="page-head">
        <h1>{t(titleKey)}</h1>
        <p className="subtitle">Screen scaffolded — implementation lands in a later phase.</p>
      </div>
      <div className="card">
        <div className="empty-state">{t(titleKey)} — coming soon.</div>
      </div>
    </div>
  );
}
